(function (global) {
  'use strict';

  function stripHtml(value) {
    return String(value || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function injectFaqSchema(container, faqs, pageUrl) {
    if (!container || !faqs || !faqs.length) return;

    var scriptId = 'tcb-faq-schema-' + (container.getAttribute('data-section-id') || 'page');
    var existing = document.getElementById(scriptId);
    if (existing) existing.remove();

    var entities = faqs
      .filter(function (item) { return item && (item.q || item.question); })
      .map(function (item) {
        return {
          '@type': 'Question',
          name: stripHtml(item.q || item.question),
          acceptedAnswer: {
            '@type': 'Answer',
            text: stripHtml(item.a || item.answer),
          },
        };
      });

    if (!entities.length) return;

    var schema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: entities,
    };

    if (pageUrl) schema.url = pageUrl;

    var script = document.createElement('script');
    script.type = 'application/ld+json';
    script.id = scriptId;
    script.textContent = JSON.stringify(schema);
    container.appendChild(script);
  }

  global.TcbFaqSchema = { inject: injectFaqSchema };
})(window);
